var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFinnTheHumanBold = function SvgFinnTheHumanBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 17.571h.01m7.99 0h.01M11 13.381h10c2.21 0 4 1.876 4 4.19v1.048c0 2.314-1.79 4.19-4 4.19H11c-2.21 0-4-1.876-4-4.19v-1.048c0-2.314 1.79-4.19 4-4.19M3 8.143c0-.834.316-1.633.879-2.222A2.93 2.93 0 0 1 6 5c.796 0 1.559.331 2.121.92A3.22 3.22 0 0 1 9 8.144h14c0-.834.316-1.633.879-2.222A2.93 2.93 0 0 1 26 5c.796 0 1.559.331 2.121.92A3.22 3.22 0 0 1 29 8.144v10.476c-.003 2.222-.847 4.352-2.347 5.922-1.5 1.571-3.532 2.456-5.653 2.459H11c-2.12-.003-4.154-.888-5.653-2.459-1.5-1.57-2.344-3.7-2.347-5.922z"
  })));
};
export default SvgFinnTheHumanBold;